import { useOutletContext } from "react-router";

import { DescriptionList } from "@prequel/shared-components";

import Timestamp from "@/components/Timestamp";
import { ExistingRecipient } from "@/types";

type RecipientDetailsProps = {
  recipient: ExistingRecipient;
};
const RecipientDetails = () => {
  const { recipient } = useOutletContext<RecipientDetailsProps>();
  return (
    <div className="mt-6">
      <DescriptionList>
        <DescriptionList.Item label="ID" value={recipient.id} />
        <DescriptionList.Item label="Name" value={recipient.name} />
        <DescriptionList.Item label="ID in Provider System" value={recipient.id_in_provider_system} />
        <DescriptionList.Item label="Products" value={recipient.products.join(", ")} />
        <DescriptionList.Item label="Created At" value={<Timestamp timestamp={recipient.created_at} />} />
        <DescriptionList.Item label="Updated At" value={<Timestamp timestamp={recipient.updated_at} />} />
      </DescriptionList>
    </div>
  );
};

export default RecipientDetails;
